import { request } from "../../api";
import { headers } from "../../../../config/config";
import { MESSAGE } from "../../../../constants/api/message";
import { AUTHORIZATION } from "../../../../constants/api/auth";
import { LogoSettings } from "../../../../types/logoSettings.types";

const { get } = request;
const { Bearer } = AUTHORIZATION;
const initialRoute = "admin/employee-page-design/preview";

type LogoSettingsPreview = LogoSettings & {
	_id?: string;
	__v?: number;
	user_id: string;
	group_number: number;
};

type Params = {
	user_id: string;
	group_number: number;
};

export const getLogoSettingsByGroupNumberAndUserId = async (params: Params): Promise<LogoSettingsPreview> => {
	try {
		const endpoint = `${initialRoute}/logo-settings/group-and-user`;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(
			endpoint,
			{
				...headers,
				Authorization: `${Bearer} ${token}`
			},
			params
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				if (result) {
					return result;
				} else {
					const logoSettings: LogoSettingsPreview = {
						logo: {
							attachment: {},
							xl: {
								height: 50,
								width: 450
							},
							lg: {
								height: 200,
								width: 100
							},
							md: {
								height: 200,
								width: 100
							},
							sm: {
								height: 200,
								width: 100
							},
							xs: {
								height: 200,
								width: 100
							}
						},
						favicon: {},
						group_number: params.group_number,
						user_id: params.user_id
					};
					return logoSettings;
				}
			}
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const logoSettingsPreview = {
	getLogoSettingsByGroupNumberAndUserId
};
